import { ElementTransformer } from '@lexical/markdown';
import { $createPageBreakNode, $isPageBreakNode, PageBreakNode } from '../../nodes/PageBreakNode';

export const PAGE_BREAK: ElementTransformer = {
  dependencies: [PageBreakNode],
  export: node => {
    return $isPageBreakNode(node) ? '\\\\newpage' : null;
  },
  regExp: /^\s*\\{1,2}newpage\s*$/,
  replace: parentNode => {
    parentNode.replace($createPageBreakNode());
  },
  type: 'element',
};
